import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {Customer} from "./customer";
import {Invoice} from "./invoice";
import {catchError} from "rxjs/operators";
import {errorObject} from "rxjs/util/errorObject";
import construct = Reflect.construct;
import {CustomerFormComponent} from "./customer-form/customer-form.component";
import {CustomerListComponent} from "./customer-list/customer-list.component";
import {InvoiceFormComponent} from "./invoice-form/invoice-form.component";
import {PaymentFormComponent} from "./payment-form/payment-form.component";
import {PaymentListComponent} from "./payment-list/payment-list.component";
import {InvoiceListComponent} from "./invoice-list/invoice-list.component";
import {e} from "@angular/core/src/render3";

@Injectable()
export class CustomerService {

  private customersUrl: string;

  constructor(private http: HttpClient) {
    this.customersUrl = window.location.protocol + "//" + window.location.hostname + "/customers";
  }

  public findAll(): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.customersUrl);
  }

  public delete(id: String, form: CustomerListComponent) {
    return this.http.delete(this.customersUrl + '/' + id).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

  public save(customer: Customer, form: CustomerFormComponent) {
    return this.http.post<Customer>(this.customersUrl, customer).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

  public findById(id: string): Observable<Customer> {
    return this.http.get<Customer>(this.customersUrl + '/' + id);
  }

  public update(customer: Customer, form: CustomerFormComponent) {
    return this.http.put(this.customersUrl, customer).pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = `${error.error.message}`;
      } else {
        errorMessage = `${error.error} (status: ${error.status})\n`;
      }
      form.myError = errorMessage;
      //window.alert(errorMessage);
      return undefined;
    }));
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-service.service.ts